module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding-new"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/onboarding"
    }
  }, [_vm._v(_vm._s(_vm.$t('Onboarding List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Onboarding New')))])])]), (_vm.notify) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert",
    class: _vm.notify.danger ? 'alert-danger' : 'alert-success'
  }, [_c('span', [_vm._v(_vm._s(_vm.notify.message))])])])]) : _vm._e(), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-top"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.user_name')))]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.user_name),
      expression: "form.user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "姓"
    },
    domProps: {
      "value": _vm._s(_vm.form.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.user_name = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.user_firstname),
      expression: "form.user_firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "名"
    },
    domProps: {
      "value": _vm._s(_vm.form.user_firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.user_firstname = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.user_name_furigana')))]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.user_name_furigana),
      expression: "form.user_name_furigana"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "せい"
    },
    domProps: {
      "value": _vm._s(_vm.form.user_name_furigana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.user_name_furigana = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.user_firstname_furigana),
      expression: "form.user_firstname_furigana"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "めい"
    },
    domProps: {
      "value": _vm._s(_vm.form.user_firstname_furigana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.user_firstname_furigana = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.email')))]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "account"
    },
    domProps: {
      "value": _vm._s(_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.email = $event.target.value
      }
    }
  })]), _vm._m(0), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.user_domain_content),
      expression: "form.user_domain_content"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.form.user_domain_content = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.domains), function(domain) {
    return _c('option', {
      domProps: {
        "value": domain.attributes['domain-content']
      }
    }, [_vm._v(_vm._s(domain.attributes['domain-content']))])
  }))])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.shop_name')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.shop_id),
      expression: "form.shop_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isShopFixed
    },
    on: {
      "change": function($event) {
        _vm.form.shop_id = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.shops), function(shop) {
    return _c('option', {
      domProps: {
        "value": shop.id
      }
    }, [_vm._v(_vm._s(shop.attributes['shop-name']))])
  })), (_vm.isShopFixed) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.shop_fixed')))]) : _vm._e()])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.user_type')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.user_type_id),
      expression: "form.user_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isClerkPattern
    },
    on: {
      "change": function($event) {
        _vm.form.user_type_id = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._l((_vm.userTypes), function(user_type) {
    return _c('option', {
      domProps: {
        "value": user_type.id
      }
    }, [_vm._v(_vm._s(user_type.attributes['user-type-name']))])
  })], 2), (_vm.isClerkPattern) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.clerk_user_type_fixed')))]) : _vm._e()])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.employment_pattern')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.employment_pattern),
      expression: "form.employment_pattern"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        _vm.form.employment_pattern = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.selectedEmploymentPattern]
    }
  }, [_c('option', {
    attrs: {
      "value": "full_time"
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.employment_pattern.full_time')))]), _c('option', {
    attrs: {
      "value": "part_free"
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.employment_pattern.part_free')))]), _c('option', {
    attrs: {
      "value": "part_80"
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.employment_pattern.part_80')))]), _c('option', {
    attrs: {
      "value": "clerk"
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.employment_pattern.clerk')))])]), (_vm.isClerkPattern) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.clerk_help')))]) : _vm._e()])]), (_vm.isPartPattern) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.shift_classes')))]), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.shiftClasses.length > 0) ? _c('div', [_vm._l((_vm.shiftClasses), function(shiftClass) {
    return _c('div', {
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.shift_class_ids),
        expression: "form.shift_class_ids"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": shiftClass.id,
        "checked": Array.isArray(_vm.form.shift_class_ids) ? _vm._i(_vm.form.shift_class_ids, shiftClass.id) > -1 : (_vm.form.shift_class_ids)
      },
      on: {
        "click": function($event) {
          var $$a = _vm.form.shift_class_ids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = shiftClass.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.form.shift_class_ids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.form.shift_class_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.form.shift_class_ids = $$c
          }
        }
      }
    }), _vm._v(_vm._s(shiftClass.view_name) + "　" + _vm._s(shiftClass.time_from) + "〜" + _vm._s(shiftClass.time_to)), (shiftClass.break_time !== null) ? _c('span', [_vm._v("（休憩 " + _vm._s(shiftClass.break_time) + "分）")]) : _vm._e()])])
  }), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.shift_classes_help')))])], 2) : _c('p', {
    staticClass: "help-block text-warning"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.no_shift_classes')))])])]) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.join_day')))]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.joinDay),
      expression: "joinDay"
    }],
    attrs: {
      "placeholder": "yyyy-mm-dd"
    },
    domProps: {
      "value": (_vm.joinDay)
    },
    on: {
      "input": function($event) {
        _vm.joinDay = $event
      }
    }
  })], 1)]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-6"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    class: _vm.saving ? 'disabled' : '',
    on: {
      "click": _vm.submit
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.button.register')))])]), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.register_help')))])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1 text-center"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("＠")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c8e751f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/onboarding-new.pug
// module id = 831
// module chunks = 1